var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.getStyle, attrs: { id: "jobsCard" } },
    [
      _c("div", {
        staticClass: "overlayed",
        style: _vm.images[0][1].exists
          ? _vm.images[0][1].custom
          : _vm.images[0][1].default,
      }),
      _vm._v(" "),
      _c("vx-card", [
        _c("h2", { staticClass: "mb-2" }, [
          _vm._v("\n        Métiers & Postes\n      "),
        ]),
        _vm._v(" "),
        _c("ul", { staticStyle: { "min-height": "50px" } }, [
          _c("li", [
            _c(
              "a",
              {
                staticClass: "link",
                attrs: { name: "cardMetier", href: "/rh/referentiel/metiers" },
              },
              [_vm._v("Consulter un métier")]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "link",
                attrs: { name: "cardPoste", href: "/rh/referentiel/postes" },
              },
              [_vm._v("Consulter un poste")]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  name: "cardEntreeMetierPoste",
                  href: "/rh/gestion/tableaux/metiers-postes",
                },
              },
              [_vm._v("Rechercher un profil adapté")]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }